<template>
  <div class="is-size-7 has-text-danger has-text-weight-bold">
    {{ formattedCostString }}
  </div>
</template>

<script>
export default {
  computed: {
    symbol () {
      return this.product?.pricing?.unit?.symbol || '$'
    },
    formattedCostString () {
      const cost = this.product?.pricing?.cost
      const low = cost?.low
      const high = cost?.high

      // Handle missing or non-numeric values
      const isLowValid = low !== null
      const isHighValid = high !== null

      if (isLowValid && isHighValid) {
        if (low === high) {
          return this.symbol + this.$numbers(low).format({ mantissa: 2 })
        } else {
          return (
            this.symbol + this.$numbers(low).format({ mantissa: 2 }) +
            ' - ' +
            this.symbol + this.$numbers(high).format({ mantissa: 2 })
          )
        }
      }

      if (isLowValid) {
        return this.symbol + this.$numbers(low).format({ mantissa: 2 })
      }

      if (isHighValid) {
        return this.symbol + this.$numbers(high).format({ mantissa: 2 })
      }

      return 'N/A' // Fallback if both are invalid or missing
    }
  },
  props: {
    product: {
      type: Object,
      required: true
    }
  }
}
</script>
